module.exports = __webpack_public_path__ + "static/media/muzzafarpur12.805b1ba2.jpeg";